module.exports = Em.Controller.extend({
    needs: ['user'],

    organization: Em.computed.alias('controllers.user.activeOrganization')
})
